document.addEventListener("DOMContentLoaded", () => {
const items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
});
item.addEventListener("mouseleave", () => {
// Use a delay to check if the mouse is still in the menu
setTimeout(() => {
if (!item.matches(":hover") && !item.querySelector("ul").matches(":hover")) {
item.removeAttribute("open");
}
}, 200); // 200ms delay
});
item.querySelector("ul").addEventListener("mouseleave", () => {
setTimeout(() => {
if (!item.matches(":hover") && !item.querySelector("ul").matches(":hover")) {
item.removeAttribute("open");
}
}, 200); // 200ms delay
});
});
});